import { Globe2 } from "lucide-react"
import { embeddedBrowserAvailabilityStore } from "../browser/availability"
import { installEmbeddedBrowserCapabilityCoordinator } from "../browser/capabilityCoordinator"
import { embeddedBrowserStore } from "../browser/store"
import { embeddedBrowserSurfaceStore } from "../browser/surfaceStore"
import { GlobalBrowserSurface } from "../components/browser/GlobalBrowserSurface"
import type { ProductModule, TrayConfig } from "./types"

const browserTrayConfig: TrayConfig = {
    id: "browser",
    insertBefore: "files",
    label: "Browser",
    icon: Globe2,
    isVisible: () => embeddedBrowserAvailabilityStore.available && embeddedBrowserSurfaceStore.isRunning,
    renderButtonStatus: () =>
        embeddedBrowserStore.pendingUserActions.size > 0 ? (
            <span className="text-[9px] font-medium text-warning">Needs you · {embeddedBrowserStore.pendingUserActions.size}</span>
        ) : embeddedBrowserStore.globalAgentPaused || embeddedBrowserStore.pausedAgentCount > 0 ? (
            <span className="text-[9px] font-medium text-warning">Paused</span>
        ) : embeddedBrowserStore.activeAgentCount > 0 ? (
            <span className="text-[9px] font-medium text-primary">Agent</span>
        ) : (
            <span className="text-[9px] font-medium text-muted">Running</span>
        ),
    getButtonLabel: () =>
        embeddedBrowserStore.pendingUserActions.size > 0
            ? `Browser · ${embeddedBrowserStore.pendingUserActions.size} request${embeddedBrowserStore.pendingUserActions.size === 1 ? "" : "s"} need${embeddedBrowserStore.pendingUserActions.size === 1 ? "s" : ""} you`
            : embeddedBrowserStore.globalAgentPaused
              ? "Browser · all agents paused after reset"
              : embeddedBrowserStore.pausedAgentCount > 0
                ? `Browser · ${embeddedBrowserStore.pausedAgentCount} agent${embeddedBrowserStore.pausedAgentCount === 1 ? "" : "s"} paused`
                : embeddedBrowserStore.activeAgentCount > 0
                  ? `Browser · ${embeddedBrowserStore.activeAgentCount} agent${embeddedBrowserStore.activeAgentCount === 1 ? "" : "s"} active`
                  : "Browser · running",
    externalPresentation: {
        canOpen: () => embeddedBrowserAvailabilityStore.available && embeddedBrowserSurfaceStore.isRunning,
        isOpen: () => embeddedBrowserSurfaceStore.isVisible,
        open: () => embeddedBrowserSurfaceStore.reveal(),
        close: () => embeddedBrowserSurfaceStore.hide(),
    },
}

export const browserModule: ProductModule = {
    id: "browser",
    install: installEmbeddedBrowserCapabilityCoordinator,
    globalSurfaces: [GlobalBrowserSurface],
    trayConfigs: [browserTrayConfig],
    taskLayout: {
        isSurfaceVisible: () => embeddedBrowserSurfaceStore.isVisible,
        isRightPaneDocked: () => embeddedBrowserSurfaceStore.isDocked,
    },
}
